import foxStoryImg from "../assets/ChatGPT_Image_May_19__2025__02_04_58_PM-removebg-preview.png";
import "./RrethNesh.css";
import { Stafi } from "./Stafi";

export function RrethNesh() {
  return (
    <>
      {/* === HERO SECTION === */}
      <section className="fox-about-hero">
        <div className="fox-about-title-row">
          <span className="fox-about-title fox-about-title-orange">Për</span>
          <img
            src={foxStoryImg}
            alt="Fox me laptop"
            className="fox-about-img-center"
          />
          <span className="fox-about-title fox-about-title-white">Ne</span>
        </div>
      </section>

      {/* === HISTORY SECTION WITH STYLISH CARD === */}
      <section className="fox-history-section">
        <div className="history-card">
          <div className="history-watermark">
            <img src={foxStoryImg} alt="" />
          </div>
          <h2 className="history-title">Si lindi Fox Academy?</h2>
          <div className="history-body">
            <p>
              Ishin dy shokë të vjetër, të apasionuar pas dizajnit, teknologjisë
              dhe kafesë së mëngjesit. Në një nga ato ditë të zakonshme në një
              kafene të Prishtinës, gjatë një bisede të thjeshtë nisi një ide që
              do të ndryshonte rrjedhën e shumë të rinjve:
              <b>“Pse të mos krijojmë një hapësirë ku çdo talent kreativ të ndihet si në shtëpi?”</b>
            </p>

            <p>
              Kështu u mboll fara e Fox Academy. Fillimi ishte modest, por i
              mbushur me energji, vizion dhe besim të ndërsjellë. Me shumë punë,
              pasion dhe mbështetje nga komuniteti, Fox Academy u kthye shpejt në
              një qendër ku bashkohen designerë, programerë, krijues për rrjetet
              sociale, fotografë, videografë dhe çdo i ri që do të sfidojë veten në
              botën digjitale.
            </p>

            <p>
              Sot, misioni vazhdon: të lidhim njerëzit me mundësitë, të
              zhvillojmë talente dhe të ndërtojmë histori suksesi që frymëzojnë.
              Çdo projekt, çdo kurs dhe çdo kafe e radhës është një hap më afër
              komunitetit kreativ që po ndërtojmë së bashku!
            </p>
          </div>
        </div>
      </section>

      <Stafi />
    </>
  );
}